import { render, staticRenderFns } from "./activitiesTable.vue?vue&type=template&id=7b65390f"
import script from "./activitiesTable.vue?vue&type=script&lang=js"
export * from "./activitiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports